module.exports = __webpack_public_path__ + "static/media/CX.ab09563b.png";